/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
    document.querySelectorAll('img[data-srcset]').forEach(img => {
      img.setAttribute('srcset', img.getAttribute('data-srcset'));
    });
    document.querySelectorAll('img[data-src]').forEach(img => {
      img.setAttribute('src', img.getAttribute('data-src'));
    });
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    try{
      const addItems = [];
      const submitButton = this.querySelector('[type="submit"]');
      const qtyInput = this.querySelector('[data-qty-input]');
      
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
      
      // Get form data
      let itemToAdd = JSON.parse(serializeForm(this.form));
      
      // Check if collection subscription mode is enabled
      const subscriptionManager = window.collectionSubscriptionManager;
      if (subscriptionManager?.isSubscriptionMode) {
        // Get current variant data to check subscription availability
        const variantSelects = this.querySelector('variant-selects') || this.querySelector('variant-radios');
        const currentVariant = variantSelects?.currentVariant;
        
        // Get the frequency selector from this specific product card
        const frequencySelector = this.querySelector('[data-product-subscription-frequency]');
        const selectedSellingPlanId = frequencySelector?.value;
        
        // Check if product supports subscription and a plan is selected
        if (currentVariant && subscriptionManager.productHasSubscription(currentVariant) && selectedSellingPlanId) {
          // Use the selling plan ID directly from the dropdown
          itemToAdd.selling_plan = selectedSellingPlanId;
        }
      }
      
      addItems.push(itemToAdd);
      const body = JSON.stringify({
        items: addItems,
        sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
      });
      
      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(async (res) => {
        let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
        if(dataJSON.errors){
          console.error(dataJSON.errors)
        }
  
        if(document.querySelector('#PopupModal-quickshop')){
          document.querySelector('#PopupModal-quickshop .close-quickshop')?.dispatchEvent(new Event('click'))
        }
        if(qtyInput) qtyInput.value = 1;
        let swatch_form = document.querySelectorAll('.swatch');
          swatch_form.forEach( ele => {
              ele.classList.contains('loading') ? ele.classList.remove('loading') : '';
          })
  
        if (!dataJSON.errors) {
          if(this.cartElement){
            let packageProtectionIndex = window.globalVariables.cart.items.findIndex((item) => {
              return item.properties['_shipping_protection'] == true;
            });
            if ((window.globalVariables.cart.attributes['_shipping_protection'] == undefined || window.globalVariables.cart.attributes['_shipping_protection'] == 'N/A') && packageProtectionIndex == -1) {
              document.dispatchEvent(autoAddShippingProtectionEvent);
              await new Promise(resolve => setTimeout(resolve, 1000));
            }
            this.cartElement.getCartData('open_drawer');
          }else if(document.querySelector('.cart-count')){
            document.querySelector('.cart-count')?.classList.remove('d-none');
          }else{
            window.location.href = window.routes.cart_fetch_url;
          }      
        }
      })
      .catch((e) => {
        console.error(e);
        Utility._rollBar(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
    }catch(err){
      console.error(err,'error')
      Utility._rollBar(err)
    }
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget?.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.addEventListener('click',(event)=>{
      // Handle dummy bundle options before any other processing
      if (event.target.closest('[data-dummy-bundle-option]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.handleDummyBundleOption(event.target.closest('[data-dummy-bundle-option]'));
        return;
      }
      
      let inputEle = event.target.closest('input');
      if(inputEle){
        if(inputEle !=null || inputEle.hasAttribute('checked')){
          this.onVariantChange(event);
        }
      }
    })
  }

  connectedCallback() {
    // Prevent double initialization
    if (this._initialized) return;
    
    this.form = this.closest('form') || this.closest('.form-element');
    if(!this.form) return;
    
    this._initialized = true;
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    if(this.formType == 'product-page') this.onVariantChange('load');
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
      
      this.setCurrentVariant();
      if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
      document.dispatchEvent(new Event('variant:changed'));
      
      if (!this.currentVariant) {
        this.toggleAddButton('disable');
        this.updateOptionLabel(this.form); 
      } else {
        if(this.formType == 'grid'){
          const productGrid = this.closest('[data-product-grid]');
          this.renderProductInfo(this.currentVariant, productGrid);
          this._updateLinks(productGrid); 
        }else{
          const productPage = this.closest('[data-product-container]');
          this.renderProductInfo(this.currentVariant, productPage);
        }
        this.updateURLandID(this.currentVariant);
        this.toggleAddButton('enable');

        if (this.form.querySelectorAll('[data-onetime-price]').length || this.form.querySelectorAll('[data-comparePrice]').length) {
          const price = this.currentVariant?.price;
          const compareAt = this.currentVariant?.compare_at_price;
          const fmt = window.globalVariables?.money_format;

          const priceHTML = (price != null && fmt) ? Utility.formatMoney(price, fmt) : null;
          const compareHTML = (compareAt != null && fmt) ? Utility.formatMoney(compareAt, fmt) : null;
          const hasCompare = compareAt != null && price != null && compareAt > price && compareHTML;

          this.form.querySelectorAll('[data-onetime-price]').forEach((ele) => {
            if (priceHTML) ele.innerHTML = priceHTML;
          });
          this.form.querySelectorAll('[data-comparePrice]').forEach((el) => {
            if (hasCompare) {
              el.innerHTML = compareHTML;
              el.classList.remove('d-none');
            } else {
              el.innerHTML = '';
              el.classList.add('d-none');
            }
          });
        }
        // if (this.form.querySelectorAll('[data-subscription_price]').length) {
        //   this.form.querySelectorAll('[data-subscription_price]').forEach((ele)=>{
        //     ele.innerHTML = Utility.formatMoney(this.currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format)
        //   })
        // }


        if(_event != 'load')  {
          const container = _event.target?.closest('[data-product-container]');
          const fmt = window.globalVariables?.money_format;

          // Update one-time current + compare
          container?.querySelectorAll('[data-onetime-price]').forEach((ele) => {
            if (this.currentVariant?.price != null && fmt) {
              ele.innerHTML = Utility.formatMoney(this.currentVariant.price, fmt);
            }
          });
          container?.querySelectorAll('[data-comparePrice]').forEach((el) => {
            const price = this.currentVariant?.price;
            const compareAt = this.currentVariant?.compare_at_price;
            if (price != null && compareAt != null && compareAt > price && fmt) {
              el.innerHTML = Utility.formatMoney(compareAt, fmt);
              el.classList.remove('d-none');
            } else {
              el.innerHTML = '';
              el.classList.add('d-none');
            }
          });

          // Update subscription price (match selected selling plan allocation if possible)
          container?.querySelectorAll('[data-subscription_price]').forEach((ele)=>{
            const selectedPlanId = container
              ?.querySelector('[data-purchase_type="subscription"] select')
              ?.value;
            const allocation =
              selectedPlanId && Array.isArray(this.currentVariant?.selling_plan_allocations)
                ? this.currentVariant.selling_plan_allocations.find((a) => String(a?.selling_plan?.id) === String(selectedPlanId))
                : this.currentVariant?.selling_plan_allocations?.[0];

            let subHTML = null;
            if (allocation?.price != null && fmt) {
              subHTML = Utility.formatMoney(allocation.price, fmt);
            } else {
              const dis = Number.parseFloat(
                container?.querySelector('[data-purchase_type="subscription"] select')?.selectedOptions?.[0]?.getAttribute('discount')
              );
              if (Number.isFinite(dis) && this.currentVariant?.price != null && fmt) {
                const discountedCents = Math.round(this.currentVariant.price * (100 - dis) / 100);
                subHTML = Utility.formatMoney(discountedCents, fmt);
              }
            }

            if (!subHTML) return;
            if (ele.closest('[data-select-subscription_price]')) {
              const base = ele.innerText.split(fmt.replaceAll('{{amount}}',''))?.[0] || '';
              ele.innerText = `${base} ${subHTML}`;
            } else {
              ele.innerHTML = subHTML;
            }
          })
          _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-subscription_percentage]').forEach((ele)=>{
            const pct = Number.parseFloat(this.currentVariant?.recharge_discount_percentage);
            if (!Number.isFinite(pct)) return;
            ele.innerHTML = `${pct}% off`;
          })

          if (this.form.querySelector('recharge-widget')) {
            const widget = this.form.querySelector('recharge-widget');
            if (widget && typeof widget._toggleOptions === 'function') widget._toggleOptions(_event);
            if (widget && typeof widget._changeSellingPlan === 'function') widget._changeSellingPlan(_event);
            if (widget && typeof widget.triggerPurchaseTypeFromURL === 'function') widget.triggerPurchaseTypeFromURL();
            let selectedItemType = this.form.querySelector('[data-purchase_type].selected')?.getAttribute('data-purchase_type') || 'onetime';
            if (selectedItemType == 'onetime') {
              let onetime_price = this.form.querySelector('[data-onetime-price]').innerHTML;
              this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = onetime_price; 
              if (this.form.closest('[data-product-container]').querySelector('[data-sticky-price]')) {
                this.form.closest('[data-product-container]').querySelector('[data-sticky-price]').innerHTML = onetime_price
              }
            }else{
              let subscription_price = this.form.querySelector('[data-subscription_price]').innerHTML;
              this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = subscription_price;
              if (this.form.closest('[data-product-container]').querySelector('[data-sticky-price]')) {
                this.form.closest('[data-product-container]').querySelector('[data-sticky-price]').innerHTML = subscription_price
              }
            }
          }

        }
        
        let swatchForm = this.closest('product-form[data-form-productswatch]');
        if(swatchForm){
          _event.target.closest('.swatch').classList.add('loading');
        }
        (swatchForm && swatchForm.querySelector('[data-btn_submit]')) ? swatchForm.querySelector('[data-btn_submit]').click() : '';
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if(!lable || !lableID) return;
      lable.innerHTML = this.currentVariant[lableID];
    });

    let stickyAddtocart = form.querySelector('[data-stick-add-to-cart]');
    if (stickyAddtocart) {
      let variantTitleEle = stickyAddtocart.querySelector('[data-variant-title]');
      if (variantTitleEle) {
        variantTitleEle.innerHTML = this.currentVariant.title
      }
    }
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    const input = this.form.querySelector('input[name="id"]');
    if (input) {
      input.value = currentVariant.id;
    }
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let price = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    
    const isCollectionCard = this.formType === 'grid';
    const priceWrapper = isCollectionCard
      ? container
      : (container?.matches?.('.m-price')
          ? container
          : (container.querySelector('.m-price') || container.closest?.('.m-price')));
    let priceElement = priceWrapper?.querySelector('[data-currentPrice]');
    let comparePriceElement = priceWrapper?.querySelectorAll('[data-comparePrice]') || [];
    let stickyPriceElement = container.querySelector('[data-sticky-price]');
    if (!priceWrapper) return;
    
    // Only handle collection cards subscription logic
    if (isCollectionCard) {
      // Get subscription price from data attributes (for collection cards only)
      const subscriptionPriceElement = this.form.querySelector(`[data-variant-subscription-price][data-variant-id="${currentVariant.id}"]`);
      const subscriptionPrice = subscriptionPriceElement?.getAttribute('data-subscription-price');
      
      // Update data attributes for subscription manager
      if (priceElement) {
        priceElement.setAttribute('data-onetime-price', currentVariant.price);
        
        if (subscriptionPrice) {
          priceElement.setAttribute('data-subscription-price', subscriptionPrice);
        } else {
          priceElement.removeAttribute('data-subscription-price');
        }
      }
      
      // Update compare price data attribute
      if (comparePriceElement.length) {
        comparePriceElement.forEach((compareEle)=>{
          compareEle.setAttribute('data-compare-at-price', currentVariant.compare_at_price || 0);
        });
      }
      
      // Check subscription mode
      const subscriptionManager = window.collectionSubscriptionManager;
      const isSubscriptionMode = subscriptionManager?.isSubscriptionMode;
      const hasSubscription = subscriptionPrice !== null && subscriptionPrice !== undefined;
      
      if (isSubscriptionMode && hasSubscription) {
        // Collection card with subscription mode ON
        const formattedSubPrice = Utility.formatMoney(subscriptionPrice, window.globalVariables.money_format);
        
        if (priceElement) {
          priceElement.innerHTML = formattedSubPrice;
          priceElement.classList.add('text-secondary-4');
          priceElement.classList.add('fw-semibold');
          priceElement.classList.remove('fw-medium');
        }
        
        // Show one-time price as strikethrough
        if (comparePriceElement.length) {
          comparePriceElement.forEach((compareEle)=>{
            compareEle.innerHTML = price;
            compareEle.classList.remove('d-none');
          });
        }
        
        if (stickyPriceElement) {
          stickyPriceElement.innerHTML = formattedSubPrice;
        }
      } else {
        // Collection card with toggle OFF - show regular price only
        if (priceElement) {
          priceElement.innerHTML = price;
          priceElement.classList.remove('text-secondary-4');
          priceElement.classList.remove('fw-semibold');
          priceElement.classList.add('fw-medium');
        }
        
        // Hide compare price
        if (comparePriceElement.length) {
          comparePriceElement.forEach((compareEle)=>{
            compareEle.classList.add('d-none');
          });
        }
        
        if (stickyPriceElement) {
          stickyPriceElement.innerHTML = price;
        }
      }
    } else {
      // Product page - original behavior, don't touch anything
      if (stickyPriceElement) {
        stickyPriceElement.innerHTML = price;
      }
      if(priceElement) priceElement.innerHTML = price;
      
      if(comparePriceElement.length) {
        comparePriceElement.forEach((compareEle)=>{
          compareEle.innerHTML = compare_price;
          if(currentVariant.compare_at_price <= 0 || compare_price == price){
            compareEle.classList.add('d-none');
          }else{
            compareEle.classList.remove('d-none');
          }
        })
        if(currentVariant.compare_at_price <= 0 || compare_price == price){
          priceElement?.classList.remove('text-secondary-4');
          priceElement?.classList.remove('fw-semibold');
          priceElement?.classList.add('fw-medium');
        }else{
          priceElement?.classList.add('text-secondary-4');
          priceElement?.classList.remove('fw-medium');
          priceElement?.classList.add('fw-semibold');
        }
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;
      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(this.formType == 'quickshop' && quickShopSlider){
          quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }

    // Keep sticky add-to-cart bar image in sync with selected variant
    if (this.formType !== 'grid') {
      const stickyImgs = container.querySelectorAll('[data-sticky-variant-image]');
      if (stickyImgs.length) {
        const src =
          currentVariant?.featured_image?.src ||
          currentVariant?.featured_media?.preview_image?.src ||
          null;

        if (src) {
          stickyImgs.forEach((img) => {
            try {
              img.setAttribute('src', src);
              img.setAttribute('srcset', src);
              if (currentVariant?.name) img.setAttribute('alt', currentVariant.name);
            } catch (e) {}
          });
        }
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    let addToCartText = this.addBtn?.getAttribute('data-add-to-cart') || window.variantStrings.addToCart;
    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      this.addBtn.classList.add('disabled');
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      this.addBtn.classList.add('disabled');
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      this.addBtn.classList.remove('disabled');
      if (this.addBtn.querySelector('.add-text')) {
        if(this.form.classList.contains('cart-upsell-form')){
          this.addBtn.querySelector('.add-text').innerHTML = `<span class="icon-plus"></span>${window.variantStrings.upsellAddText.trim()}`;
        }else{
          this.addBtn.querySelector('.add-text').textContent = addToCartText;
        }
      }
    }
  }

  /**
   * Handle dummy bundle option clicks by opening URL in new tab
   * @param {element} dummyBundleElement 
   */
  handleDummyBundleOption(dummyBundleElement) {
    const productUrl = dummyBundleElement.getAttribute('data-dummy-bundle-option');
    if (productUrl) {
      // Open the product URL in a new tab
      window.open(productUrl, '_blank');
    }
  }





  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || (this.variant_json ? JSON.parse(this.variant_json?.textContent) : false);
    return this.variantData;
}
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form?.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]')?.dataset?.handle;
        if(!colorHandle) return;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      })
    }
  }
}
customElements.define('variant-radios', VariantRadios);

class rechargeWidget extends HTMLElement {
  constructor() {
    super();
    
    this.optionSelectors = this.querySelectorAll('[data-purchase_type]');
    this.optionSelectors.forEach(option => option.addEventListener('click', this._toggleOptions.bind(this)));

    setTimeout(() => {
      this.optionSelectors.forEach(option => option.addEventListener('click', this._adjustURLParameter.bind(this)));
    }, 2000);

    this.sellingPlans=this.querySelectorAll('[data-purchase_type="subscription"] select');
    this.sellingPlans.forEach(plan => plan.addEventListener('change', this._changeSellingPlan.bind(this)));

    this.subscriptionSellingPlan = this.querySelector('[data-purchase_type="subscription"] [name="selling_plan"]');
    if (this.subscriptionSellingPlan) {
      this.subscriptionSellingPlan.checked = true;
    }
    // Trigger purchase type from URL parameter
    if(!window.location.search.includes('purchase_type=subscription')){
      this.querySelector('[data-purchase_type="subscription"] label')?.click();
      this.querySelector('select')?.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.triggerPurchaseTypeFromURL();
    

  }
  _setSubscriptionDiscountUI({ container, mode, discountPercent, onetimePriceHTML }) {
    if (!container) return;

    // Scope to the widget to avoid touching other price blocks in the product container
    const compareEls = this.querySelectorAll('[data-comparePrice]');
    const badgeEl = container.querySelector('[data-subscription-discount-badge]');
    const percentageEls = this.querySelectorAll('[data-subscription_percentage]');

    const pct = Number.parseFloat(discountPercent);
    const pctText = Number.isFinite(pct) && pct > 0 ? `${(pct % 1 === 0 ? pct.toFixed(0) : pct)}% OFF` : '';
    const pctTextLower = Number.isFinite(pct) && pct > 0 ? `${(pct % 1 === 0 ? pct.toFixed(0) : pct)}% off` : '';

    if (mode === 'subscription') {
      const currentVariant = window.globalVariables?.product?.currentVariant;
      const moneyFormat = window.globalVariables?.money_format;
      const price = currentVariant?.price;
      const compareAt = currentVariant?.compare_at_price;
      const formattedCompareAt = (compareAt != null && moneyFormat) ? Utility.formatMoney(compareAt, moneyFormat) : null;

      const hasCompare =
        compareEls.length &&
        compareAt != null &&
        price != null &&
        compareAt > price &&
        formattedCompareAt;

      if (compareEls.length) {
        compareEls.forEach((el) => {
          if (hasCompare) {
            el.innerHTML = formattedCompareAt;
            el.classList.remove('d-none');
          } else {
            // If no valid compare-at price, hide the strike element (do not overwrite with one-time)
            el.innerHTML = '';
            el.classList.add('d-none');
          }
        });
      }
      if (badgeEl) {
        if (pctText) {
          badgeEl.textContent = pctText;
          badgeEl.classList.remove('d-none');
        } else {
          badgeEl.classList.add('d-none');
          badgeEl.textContent = '';
        }
      }

      // Keep the inline "xx% off" text in sync (rc-radio__handle-recharge)
      if (percentageEls.length && pctTextLower) {
        percentageEls.forEach((el) => {
          el.textContent = pctTextLower;
        });
      }
    } else {
   
      const currentVariant = window.globalVariables?.product?.currentVariant;
      const moneyFormat = window.globalVariables?.money_format;
      const price = currentVariant?.price;
      const compareAt = currentVariant?.compare_at_price;
      const formattedPrice = (price != null && moneyFormat) ? Utility.formatMoney(price, moneyFormat) : null;
      const formattedCompareAt = (compareAt != null && moneyFormat) ? Utility.formatMoney(compareAt, moneyFormat) : null;

      console.log('[rechargeWidget] onetime mode: start', {
        compareEls: compareEls.length,
        price,
        compareAt,
        formattedPrice,
        formattedCompareAt
      });

      if (compareEls.length) {
        compareEls.forEach((el) => {
          if (!formattedCompareAt || !formattedPrice || compareAt <= 0 || formattedCompareAt === formattedPrice) {
            el.classList.add('d-none');
          } else {
            el.innerHTML = formattedCompareAt;
            el.classList.remove('d-none');
          }
        });
      }

      // If compare price equals the one-time price, hide it (prevents pointless strike-through)
      if (compareEls.length) {
        compareEls.forEach((el) => {
          const priceWrap = el.closest('.rc-radio__price');
          const oneTimeEl = priceWrap?.querySelector('[data-onetime-price]');
          if (!oneTimeEl) return;
          const compareText = el.textContent.trim();
          const oneTimeText = oneTimeEl.textContent.trim();
          console.log('[rechargeWidget] compare vs onetime', {
            compareText,
            oneTimeText,
            equal: compareText === oneTimeText,
            el,
            oneTimeEl
          });
          if (compareText === oneTimeText) {
            el.classList.add('d-none');
          }
        });
      }

      if (badgeEl) {
        badgeEl.classList.add('d-none');
        badgeEl.textContent = '';
      }
    }
  }

  _getSelectedSellingPlanId(container) {
    return (
      container
        ?.querySelector('[data-purchase_type="subscription"] select')
        ?.value || null
    );
  }

  _getSubscriptionAllocationCents(container) {
    const currentVariant = window.globalVariables?.product?.currentVariant;
    if (!currentVariant || !Array.isArray(currentVariant.selling_plan_allocations)) return null;

    const selectedPlanId = this._getSelectedSellingPlanId(container);
    const allocation = selectedPlanId
      ? currentVariant.selling_plan_allocations.find(
          (a) => String(a?.selling_plan?.id) === String(selectedPlanId)
        )
      : currentVariant.selling_plan_allocations[0];

    return typeof allocation?.price === 'number' ? allocation.price : null;
  }

  _getDiscountPercentForDisplay({ container }) {
    const currentVariant = window.globalVariables?.product?.currentVariant;
    if (!currentVariant) return null;

    const price = currentVariant.price;
    const compareAt = currentVariant.compare_at_price;
    let subCents = this._getSubscriptionAllocationCents(container);

    // Fallback: if allocations aren't present in variant JSON, compute from selected option's discount (% off price)
    if (typeof subCents !== 'number') {
      const discountAttr = container
        ?.querySelector('[data-purchase_type="subscription"] select')
        ?.selectedOptions?.[0]
        ?.getAttribute('discount');
      const discountPct = Number.parseFloat(discountAttr);
      if (Number.isFinite(discountPct) && typeof price === 'number') {
        subCents = Math.round(price * (100 - discountPct) / 100);
      }
    }

    const base =
      typeof compareAt === 'number' &&
      typeof price === 'number' &&
      compareAt > price
        ? compareAt
        : price;

    if (typeof base !== 'number' || base <= 0 || typeof subCents !== 'number') return null;

    // Use floor so it matches "51% off" expectation on 300 → 146.25 (= 51.25%)
    return Math.floor(((base - subCents) / base) * 100);
  }

  _formatUnitPrice(cents) {
    return Utility
      .formatMoney(cents, window.globalVariables.money_format)
      .replace(/(\.\d*[1-9])0(?=\D*$)/, '$1')
      .replace(/\.00(?=\D*$)/, '');
  }

  _updateVariantAddInfo({ container, mode, discountPercent }) {
    if (!container) return;

    container.querySelectorAll('[data-variant-add-info]').forEach((el) => {
      const onetimePricePerGummy = Number.parseFloat(el.getAttribute('data-onetime-price-per-gummy'));
      const subscriptionPricePerGummy = Number.parseFloat(el.getAttribute('data-subscription-price-per-gummy'));
      const discount = Number.parseFloat(discountPercent);
      let pricePerGummy = onetimePricePerGummy;

      if (mode === 'subscription') {
        if (Number.isFinite(discount) && discount > 0 && Number.isFinite(onetimePricePerGummy)) {
          pricePerGummy = onetimePricePerGummy - (onetimePricePerGummy * discount / 100);
        } else if (Number.isFinite(subscriptionPricePerGummy)) {
          pricePerGummy = subscriptionPricePerGummy;
        }
      }

      if (Number.isFinite(pricePerGummy)) {
        el.textContent = `${this._formatUnitPrice(pricePerGummy)} / gummy`;
      }
    });
  }

  _adjustURLParameter(event){
    const urlParams = new URLSearchParams(window.location.search);
    let purchaseType = event.target.closest('[data-purchase_type]')?.getAttribute('data-purchase_type') || 'subscription';
    urlParams.set('purchase_type', purchaseType);
    window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());
  }
  _toggleOptions(event){
    this.form=event.target.closest('form');
    if (this.form.closest('[data-product-container]') && this.form.querySelector('recharge-widget')) {
      this.type=this.form.querySelector('[name="selling_plan"]:checked')?.closest('[data-purchase_type]')?.getAttribute('data-purchase_type');
      document.querySelector('[data-purchase_type].selected')?.classList.remove('selected');
      document.querySelector(`[data-purchase_type="${this.type}"]`)?.classList.add('selected');
    }
    let stickyPriceElement = this.form.closest('[data-product-container]').querySelector('[data-sticky-price]');
    const container = this.form.closest('[data-product-container]');
    if (this.type == 'onetime') {
      let onetime_price = this.form.querySelector('[data-onetime-price]').innerHTML;
      if(this.form.closest('[data-product-container]')?.querySelector('[data-currentprice]')){
        this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = onetime_price;
      }
      if (stickyPriceElement) {
        stickyPriceElement.innerHTML = `${onetime_price}`;
      }
      this._updateVariantAddInfo({ container, mode: 'onetime' });
      this._setSubscriptionDiscountUI({ container, mode: 'onetime' });

      // Keep main PDP price block (.m-price) in sync for onetime mode
      const mPrice = container?.querySelector('.m-price');
      if (mPrice) {
        const currentEl = mPrice.querySelector('[data-currentPrice]');
        if (currentEl) currentEl.innerHTML = onetime_price;

        const compareEls = mPrice.querySelectorAll('[data-comparePrice]');
        const currentVariant = window.globalVariables?.product?.currentVariant;
        const moneyFormat = window.globalVariables?.money_format;
        const formattedPrice = (currentVariant?.price != null && moneyFormat) ? Utility.formatMoney(currentVariant.price, moneyFormat) : null;
        const formattedCompareAt = (currentVariant?.compare_at_price != null && moneyFormat) ? Utility.formatMoney(currentVariant.compare_at_price, moneyFormat) : null;

        if (compareEls.length) {
          compareEls.forEach((el) => {
            if (!formattedCompareAt || !formattedPrice || currentVariant.compare_at_price <= 0 || formattedCompareAt === formattedPrice) {
              el.classList.add('d-none');
            } else {
              el.innerHTML = formattedCompareAt;
              el.classList.remove('d-none');
            }
          });
        }
      }
    }else{
      let subscription_price = this.form.querySelector('[data-subscription_price]').innerHTML;
      if(this.form.closest('[data-product-container]')?.querySelector('[data-currentprice]')){
        this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = subscription_price;
      }
      if (stickyPriceElement) {
        stickyPriceElement.innerHTML = `${subscription_price}`;
      }
      const onetimePriceHTML = this.form.querySelector('[data-onetime-price]')?.innerHTML;
      const discountForDisplay = this._getDiscountPercentForDisplay({ container });
      this._setSubscriptionDiscountUI({
        container,
        mode: 'subscription',
        discountPercent: discountForDisplay,
        onetimePriceHTML
      });
      this._updateVariantAddInfo({
        container,
        mode: 'subscription',
        discountPercent: discountForDisplay
      });

      // Keep main PDP price block (.m-price) in sync for subscription mode
      const mPrice = container?.querySelector('.m-price');
      if (mPrice) {
        const currentEl = mPrice.querySelector('[data-currentPrice]');
        if (currentEl) currentEl.innerHTML = subscription_price;

        const compareEls = mPrice.querySelectorAll('[data-comparePrice]');
        const currentVariant = window.globalVariables?.product?.currentVariant;
        const moneyFormat = window.globalVariables?.money_format;
        const formattedCompareAt =
          currentVariant?.compare_at_price != null && moneyFormat
            ? Utility.formatMoney(currentVariant.compare_at_price, moneyFormat)
            : null;
        const formattedPrice =
          currentVariant?.price != null && moneyFormat
            ? Utility.formatMoney(currentVariant.price, moneyFormat)
            : null;
        if (compareEls.length) {
          compareEls.forEach((el) => {
            if (!formattedCompareAt || !formattedPrice || currentVariant.compare_at_price <= 0 || formattedCompareAt === formattedPrice) {
              el.classList.add('d-none');
              el.innerHTML = '';
            } else {
              el.innerHTML = formattedCompareAt;
              el.classList.remove('d-none');
            }
          });
        }
      }
    }
  }

  _changeSellingPlan(event){
    let target = event.target;
    if (!target.closest('recharge-widget')) {
      target = event.target.closest('product-form')?.querySelector('recharge-widget select')
    }
    let id=target.value;
    let dis=target?.selectedOptions[0]?.getAttribute('discount') || 0;
    let container = target.closest('[data-product-container]');
    const moneyFormat = window.globalVariables?.money_format;
    const variantCents = window.globalVariables?.product?.currentVariant?.price;
    const discountPercentage = Number.parseFloat(dis);
    const discountedCents =
      Number.isFinite(discountPercentage) && typeof variantCents === 'number'
        ? Math.round(variantCents * (100 - discountPercentage) / 100)
        : null;
    target.closest('[data-purchase_type]').querySelector('[name="selling_plan"]').value=id;
    const discountForDisplay = this._getDiscountPercentForDisplay({ container });
    const subscriptionPercentageEl = target.closest('[data-purchase_type]')?.querySelector('[data-subscription_percentage]');
    if (subscriptionPercentageEl && Number.isFinite(discountForDisplay)) {
      subscriptionPercentageEl.innerHTML = `${discountForDisplay}% off`;
    }
    if (discountedCents != null && moneyFormat) {
      target.closest('[data-purchase_type]').querySelector('[data-subscription_price]').innerHTML = `${Utility.formatMoney(discountedCents, moneyFormat)}`;
      target.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = `${Utility.formatMoney(discountedCents, moneyFormat)}`;
    }
    if (target.closest('[data-product-container]').querySelector('[data-sticky-price]')) {
      if (discountedCents != null && moneyFormat) {
        target.closest('[data-product-container]').querySelector('[data-sticky-price]').innerHTML = `${Utility.formatMoney(discountedCents, moneyFormat)}`
      }
    }

    // Sync main PDP price block (.m-price) with updated subscription price
    const mPrice = container?.querySelector('.m-price');
    if (mPrice) {
      const currentEl = mPrice.querySelector('[data-currentPrice]');
      if (currentEl && discountedCents != null && moneyFormat) currentEl.innerHTML = `${Utility.formatMoney(discountedCents, moneyFormat)}`;

      const compareEls = mPrice.querySelectorAll('[data-comparePrice]');
      const product_price = container?.querySelector('[data-onetime-price]')?.innerHTML || document.querySelector('[data-onetime-price]')?.innerHTML;
      if (compareEls.length && product_price) {
        compareEls.forEach((el) => {
          el.innerHTML = product_price;
          el.classList.remove('d-none');
        });
      }
    }

    this._setSubscriptionDiscountUI({
      container,
      mode: 'subscription',
      discountPercent: discountForDisplay,
      onetimePriceHTML: container?.querySelector('[data-onetime-price]')?.innerHTML
    });
    this._updateVariantAddInfo({
      container,
      mode: 'subscription',
      discountPercent: dis
    });
  }

  // Trigger purchase type label based on URL parameter
  triggerPurchaseTypeFromURL() {
    try {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const purchaseType = urlParams.get('purchase_type');

        // If purchase_type parameter exists
        if (purchaseType && (purchaseType === 'onetime' || purchaseType === 'subscription')) {
            // Find the label with matching data-purchase_type attribute
            const targetLabel = document.querySelector(`[data-purchase_type="${purchaseType}"] label`);
            if (targetLabel) {
              document.querySelector(`[data-purchase_type="${purchaseType}"] input`).checked = true;
              targetLabel.click();
            }
        }
    } catch (error) {
        console.error('Error triggering purchase type from URL:', error);
    }
  }
}
customElements.define('recharge-widget', rechargeWidget);

(function() {
  // Override pushState
  const pushState = history.pushState;
  history.pushState = function(...args) {
      pushState.apply(this, args);
      window.dispatchEvent(new Event('urlchange'));
  };

  // Override replaceState
  const replaceState = history.replaceState;
  history.replaceState = function(...args) {
      replaceState.apply(this, args);
      window.dispatchEvent(new Event('urlchange'));
  };

  // Listen for back/forward
  window.addEventListener('popstate', () => {
      window.dispatchEvent(new Event('urlchange'));
  });

  // Yotpo Price change on URL change
  window.addEventListener('urlchange', () => {
    let yotpoPriceElement = document.querySelector('.yotpo-product-points-widget-points-amount');
    if(yotpoPriceElement){
      setTimeout(() => {
        let itemPrice = yotpoPriceElement.closest('.product-details-wrapper')?.querySelector('[data-currentprice]')?.innerText.replace('$','');
        yotpoPriceElement.innerHTML = itemPrice;
      }, 500);
    }
  });
})();
